import { render, staticRenderFns } from "./terveyskeskuskoulutusjakso-form.vue?vue&type=template&id=739af110&scoped=true&"
import script from "./terveyskeskuskoulutusjakso-form.vue?vue&type=script&lang=ts&"
export * from "./terveyskeskuskoulutusjakso-form.vue?vue&type=script&lang=ts&"
import style0 from "./terveyskeskuskoulutusjakso-form.vue?vue&type=style&index=0&id=739af110&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739af110",
  null
  
)

export default component.exports